import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { permisopagina } from '../models/permisopagina';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  
  url = environment.baseUrl+ '/api/security/GetPermisos';

  constructor(private http: HttpClient) {}

  loadPermissions(): Observable<permisopagina[]> {
    return this.http.post<permisopagina[]>(this.url, {}, httpOption).pipe(
      map((res: permisopagina[]) => {
        if (res !== undefined) {
          localStorage.setItem('permisosMenu', JSON.stringify(res));
        }
        return res;
      })
    );
  }


}
